<template>
  <div class="flex flex-col gap-2 p-4">
    <div>camera settings X: {{ cameraPositionRef.x }}, Y: {{ cameraPositionRef.y }}, Z: {{ cameraPositionRef.z }}</div>

    <div class="flex gap-2">
      <DButton @click="rotateControls(-45)" label="rotate theta -45deg" />
      <DButton @click="rotateControls(45)" label="rotate theta 45deg" />
    </div>
    <div class="flex gap-2">
      <DButton @click="() => isometricView(canvasContainer)" label="orthographic" />
      <DButton @click="() => perspectiveView(canvasContainer)" label="perspective" />
    </div>
    <div v-if="isOrthographicView" class="flex flex-col justify-center gap-2">
      <DButton @click="snapToTopView" label="top view" />
      <div class="flex gap-2">
        <DButton @click="snapToSideView(true)" label="side view left" />

        <DButton @click="snapToFrontView" label="front view" />

        <DButton @click="snapToSideView(false)" label="side view right" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCameraControls } from '@/composables/useCameraControls';
import { useWebsockets } from '@/composables/useWebsockets';
import { DButton } from '@disguise/cloud-ui';
import { onBeforeUnmount, onMounted } from 'vue';

const props = defineProps({
  canvasContainer: {
    type: Object,
    required: true,
  },
});

const { sendCameraPosition } = useWebsockets();

// Camera controls
const {
  isOrthographicView,
  cameraPositionRef,
  rotateControls,
  isometricView,
  perspectiveView,
  snapToFrontView,
  snapToTopView,
  snapToSideView,
  initCameraControls,
} = useCameraControls(sendCameraPosition);

let cleanupCameraControls = null;

onMounted(() => {
  // Initialize camera controls
  cleanupCameraControls = initCameraControls();
});

onBeforeUnmount(() => {
  // Cleanup camera controls
  if (cleanupCameraControls) {
    cleanupCameraControls();
  }
});
</script>
